// extracted by mini-css-extract-plugin
export default {"customButton":"YndButton_customButton__NOLBh","sm":"YndButton_sm__nl8cU","md":"YndButton_md__RtM9q","lg":"YndButton_lg__+YgpG","dark":"YndButton_dark__d-zf7"};